import http from '@/http'

const PATH = '/reservation'

export default {
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listNumbers (params) {
        try {
            const response = await http.get(`${PATH}/numbers`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{number: string}} data
     * @returns {Promise<void>}
     */
    async showNumber ({number}) {
        try {
            const response = await http.get(`${PATH}/numbers/${number}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{ReservationNumberInventoryItem}} data
     * @returns {Promise<void>}
     */
    async reserveNumber (data) {
        try {
            const response = await http.put(`${PATH}/numbers/reserve/${data.service_number}`, data)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{ReservationNumberInventoryItem}} data
     * @returns {Promise<void>}
     */
    async unReserveNumber (data) {
        try {
            const response = await http.put(`${PATH}/numbers/unreserve/${data.service_number}`, data)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{ReservationNumberInventoryItem}} data
     * @returns {Promise<void>}
     */
    async sellNumber (data) {
        try {
            const response = await http.put(`${PATH}/numbers/sell/${data.service_number}`, data)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{ReservationNumberInventoryItem}} data
     * @returns {Promise<void>}
     */
    async importNumber (data) {
        try {
            const response = await http.post(`${PATH}/import/number`, data)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{}} params
     * @returns {Promise<void>}
     */
    async listAreaCodes (params) {
        try {
            const response = await http.get(`${PATH}/area-codes`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
